import React from 'react';
import { publish, publishSticky, subscribe, unsubscribe } from '@wh/message-bus';
import { StateType } from '@central-products/interface-session-service';
import { feature as myaccountFlowFeature } from '@central-products/myaccount-flow';
import { getValueForDevice, openLink, isNative } from '../../utils';
import { HEADER_TYPE_CHANGED } from '../../constants';
import { getMyAccountViewParam, removeMyAccountViewParam } from './utils';
export { MY_ACCOUNT_VIEW_QUERY_PARAM } from './utils';

const openMyAccountViewFromParam = async (params) => {
  if (typeof window === 'undefined') {
    return;
  }
  const viewParam = getMyAccountViewParam(window.location.search);
  if (viewParam) {
    publishSticky('wh.myAccount.command.myAccountView.open', {
      myAccountView: viewParam,
      params: {
        legacyMarketingConsentDeepLinkBehavior: params.legacyMarketingConsentDeepLinkBehavior,
      },
    });
    const url = removeMyAccountViewParam(window.location.search, window.location.toString());
    window.history.pushState(null, '', url);
  }
};

export const myAccountPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params, addHeaderRenderers }) {
    const neverOpen = params.neverOpenOnNative && isNative();
    addBootstrapperFeature(myaccountFlowFeature, {
      provideRenderers: addHeaderRenderers,
      promotionsUrl: params.promotionsPageUrl,
      helpPageUrl: params.helpPageUrl,
      openFeedbackTopic: params.openFeedbackTopic,
      openLink,
      neverOpen,
      version: new URLSearchParams(window.location.search).get('myAccountVersion'),
    });
  },
  beforeRender({ header, params, headerRenderers }) {
    const myAccountButtonConfig = {
      type: '@myaccount/myaccount-button',
      data: {
        id: 'hrs-action__myaccount-button',
      },
      children: [],
    };

    const myAccountModalsConfig = {
      type: '@myaccount/modals',
      data: {
        id: 'pi-header__myaccount-modals',
        urls: {
          withdraw: getValueForDevice(params.withdrawUrl),
          reversalWithdraw: getValueForDevice(params.reversalWithdrawUrl),
          pokerBalanceTransfer: getValueForDevice(params.pokerBalanceTransferUrl),
        },
      },
      children: [],
    };

    header.actions.children.splice(1, 0, myAccountButtonConfig);
    header.actions.children.push(myAccountModalsConfig);

    headerRenderers.push({
      type: '@myaccount/myaccount-button',
      render: () => <div key="cp-myacc-button" id="cp-ma-wrapper" />,
    });
  },
  async postBootstrap({ bootstrapperFeatures, params }) {
    const { state: sessionServiceState } = await bootstrapperFeatures['session-service'].getState();

    if (sessionServiceState === StateType.SESSION_EXISTS) {
      bootstrapperFeatures['my-account'].start();
    }

    let headerChangedSubscribeId = null;

    bootstrapperFeatures['session-service'].onStateChanged(({ state }) => {
      if (state === StateType.SESSION_EXISTS) {
        bootstrapperFeatures['my-account'].start();
        if (!headerChangedSubscribeId) {
          headerChangedSubscribeId = subscribe(HEADER_TYPE_CHANGED, () => {
            publish('wh.common.command.ui.myaccount.cancel');
            publish('wh.common.command.ui.myaccount.start');
          });
        }
      } else {
        unsubscribe(headerChangedSubscribeId);
        headerChangedSubscribeId = null;
      }
    });

    openMyAccountViewFromParam(params);
  },
};
